<div class="tenant-detail-container">
  <!-- 顶部操作栏 -->
  <div class="header-actions">
    <div class="left-section">
      <button
        *ngIf="shouldShowBackButton"
        class="back-icon-btn"
        nz-button
        nzType="text"
        (click)="goBack()"
        [attr.aria-label]="'tenant.detail.back' | i18n"
        [attr.title]="'tenant.detail.back' | i18n"
        [testId]="'tenant-detail-back-button'"
      >
        <nz-icon nzType="arrow-left" [testId]="'tenant-detail-back-icon'" />
        <span class="back-text">{{ 'common.back-to-list' | i18n }}</span>
      </button>
    </div>

    <div class="center-section">
      <div class="tenant-avatar">
        <nz-avatar [nzSrc]="avatarUrl" [nzSize]="64" nzIcon="user" (click)="openImageViewer(avatarUrl)" [testId]="'tenant-detail-avatar'" />
        <div class="avatar-upload">
          <button nz-button nzType="link" nzSize="small" (click)="showAvatarUploadModal()" [testId]="'tenant-detail-avatar-edit-button'">
            <nz-icon nzType="edit" nzTheme="outline" [testId]="'tenant-detail-avatar-edit-icon'" />
          </button>
        </div>
      </div>
      <div class="tenant-info">
        <nz-tag [nzColor]="getTenantTypeColor(tenantData.type)" [testId]="'tenant-detail-type-tag'">
          {{ getTenantTypeText(tenantData.type) }}
        </nz-tag>
        <h2>{{ tenantData.name }}</h2>
      </div>
    </div>

    <div class="right-section">
      <button
        *ngIf="selectedTabIndex === 0"
        nz-button
        nzType="primary"
        (click)="saveTenant()"
        [nzLoading]="loading"
        [testId]="'tenant-detail-save-button'"
      >
        <nz-icon nzType="save" [testId]="'tenant-detail-save-icon'" />
        {{ 'common.save' | i18n }}
      </button>
    </div>
  </div>

  <!-- 主内容区 -->
  <div class="content-area" *ngIf="!loading; else loadingTpl">
    <nz-tabset
      class="tenant-detail-tabset"
      [class.hide-top-tabs]="!shouldShowTopTabs"
      [(nzSelectedIndex)]="selectedTabIndex"
      (nzSelectChange)="onTabChange(selectedTabIndex)"
      [nzCanDeactivate]="canDeactivate"
      [nzAnimated]="false"
      [testId]="'tenant-detail-tabset'"
    >
      <!-- 基本信息标签页 -->
      <nz-tab [nzTitle]="basicInfoTitle" [testId]="'tenant-detail-basic-info-tab'">
        <ng-template #basicInfoTitle>
          <i nz-icon nzType="info-circle" nzTheme="outline"></i>
          {{ 'tenant.detail.basic-info' | i18n }}
        </ng-template>
        <form nz-form [formGroup]="tenantForm" [testId]="'tenant-detail-form'">
          <nz-card [nzTitle]="'tenant.detail.basic-info' | i18n" [testId]="'tenant-detail-basic-info-card'">
            <!-- 现有的名称和简称字段 -->
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-name-form-item'">
                  <nz-form-label [nzSpan]="6" nzRequired>{{ 'tenant.detail.tenant-name' | i18n }}</nz-form-label>
                  <nz-form-control
                    [nzSpan]="18"
                    [nzErrorTip]="'tenant.detail.error.tenant-name' | i18n"
                    [testId]="'tenant-detail-name-form-control'"
                  >
                    <input
                      nz-input
                      formControlName="name"
                      [placeholder]="'tenant.detail.placeholder.tenant-name' | i18n"
                      [testId]="'tenant-detail-name-input'"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-short-name-form-item'">
                  <nz-form-label [nzSpan]="6" nzRequired>{{ 'tenant.detail.tenant-short-name' | i18n }}</nz-form-label>
                  <nz-form-control
                    [nzSpan]="18"
                    [nzErrorTip]="'tenant.detail.error.tenant-short-name' | i18n"
                    [testId]="'tenant-detail-short-name-form-control'"
                  >
                    <input
                      nz-input
                      formControlName="shortName"
                      [placeholder]="'tenant.detail.placeholder.tenant-short-name' | i18n"
                      [testId]="'tenant-detail-short-name-input'"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <!-- 现有的编码和类型字段 -->
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-code-form-item'">
                  <nz-form-label [nzSpan]="6" nzRequired>{{ 'tenant.detail.tenant-code' | i18n }}</nz-form-label>
                  <nz-form-control
                    [nzSpan]="18"
                    [nzErrorTip]="'tenant.detail.error.tenant-code' | i18n"
                    [testId]="'tenant-detail-code-form-control'"
                  >
                    <input
                      nz-input
                      formControlName="code"
                      [placeholder]="'tenant.detail.placeholder.tenant-code' | i18n"
                      class="readonly-field"
                      readonly
                      [testId]="'tenant-detail-code-input'"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-type-form-item'">
                  <nz-form-label [nzSpan]="6" nzRequired>{{ 'tenant.detail.tenant-type-label' | i18n }}</nz-form-label>
                  <nz-form-control
                    [nzSpan]="18"
                    [nzErrorTip]="'tenant.detail.error.select-tenant-type' | i18n"
                    [testId]="'tenant-detail-type-form-control'"
                  >
                    <nz-select
                      formControlName="type"
                      [nzPlaceHolder]="'tenant.detail.placeholder.tenant-type-readonly' | i18n"
                      class="readonly-field"
                      [nzDisabled]="true"
                      [testId]="'tenant-detail-type-select'"
                    >
                      <nz-option
                        *ngFor="let type of tenantTypes; trackBy: trackByValue"
                        [nzValue]="type.value"
                        [nzLabel]="type.label"
                        [testId]="'tenant-detail-type-option-' + type.value"
                      />
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <!-- 新增行业和子行业字段 -->
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-industry-form-item'">
                  <nz-form-label [nzSpan]="6">{{ 'tenant.detail.industry-type' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="18" [testId]="'tenant-detail-industry-form-control'">
                    <nz-select
                      nzAllowClear
                      formControlName="industry"
                      [nzPlaceHolder]="'tenant.detail.placeholder.industry-type' | i18n"
                      (ngModelChange)="updateIndustrySubOptions($event)"
                      [testId]="'tenant-detail-industry-select'"
                    >
                      <nz-option
                        *ngFor="let item of industryOptions; trackBy: trackByValue"
                        [nzValue]="item.value"
                        [nzLabel]="item.text"
                        [testId]="'tenant-detail-industry-option-' + item.value"
                      />
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-industry-sub-form-item'">
                  <nz-form-label [nzSpan]="6">{{ 'tenant.detail.industry-sub-type' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="18" [testId]="'tenant-detail-industry-sub-form-control'">
                    <nz-select
                      nzAllowClear
                      formControlName="industrySub"
                      [nzPlaceHolder]="'tenant.detail.please-select-sub-type' | i18n"
                      [testId]="'tenant-detail-industry-sub-select'"
                    >
                      <nz-option
                        *ngFor="let item of industrySubOptions; trackBy: trackByValue"
                        [nzValue]="item.value"
                        [nzLabel]="item.text"
                        [testId]="'tenant-detail-industry-sub-option-' + item.value"
                      />
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <!-- 新增企业规模和城市字段 -->
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-scale-form-item'">
                  <nz-form-label [nzSpan]="6">{{ 'tenant.detail.company-scale' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="18" [testId]="'tenant-detail-scale-form-control'">
                    <nz-select
                      formControlName="scale"
                      [nzPlaceHolder]="'tenant.detail.placeholder.company-scale' | i18n"
                      nzAllowClear="true"
                      [testId]="'tenant-detail-scale-select'"
                    >
                      <nz-option
                        *ngFor="let item of scaleOptions; trackBy: trackByValue"
                        [nzValue]="item.value"
                        [nzLabel]="item.text"
                        [testId]="'tenant-detail-scale-option-' + item.value"
                      />
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-account-form-item'">
                  <nz-form-label [nzSpan]="6">{{ 'tenant.detail.associated-account' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="18" [testId]="'tenant-detail-account-form-control'">
                    <input
                      nz-input
                      formControlName="accountId"
                      [placeholder]="'tenant.detail.placeholder.associated-account' | i18n"
                      class="readonly-field"
                      readonly
                      [testId]="'tenant-detail-account-input'"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <!-- 新增开始和结束时间字段 -->
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-start-time-form-item'">
                  <nz-form-label [nzSpan]="6">{{ 'tenant.detail.start-time' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="18" [testId]="'tenant-detail-start-time-form-control'">
                    <nz-date-picker
                      formControlName="startTime"
                      nzFormat="yyyy-MM-dd"
                      style="width: 100%"
                      (ngModelChange)="onStartTimeChange($event)"
                      [testId]="'tenant-detail-start-time-picker'"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-end-time-form-item'">
                  <nz-form-label [nzSpan]="6">{{ 'tenant.detail.end-time' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="18" [nzErrorTip]="endTimeErrorTpl" [testId]="'tenant-detail-end-time-form-control'">
                    <nz-date-picker
                      formControlName="endTime"
                      nzFormat="yyyy-MM-dd"
                      style="width: 100%"
                      [testId]="'tenant-detail-end-time-picker'"
                    />
                    <ng-template #endTimeErrorTpl let-control>
                      <ng-container *ngIf="control.hasError('endTimeInvalid')">{{
                        'tenant.detail.error.end-time-invalid' | i18n
                      }}</ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <!-- 新增统一社会信用代码和法人代表号码字段 -->
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-unified-number-form-item'">
                  <nz-form-label [nzSpan]="6">{{ 'tenant.detail.unified-number' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="18" [testId]="'tenant-detail-unified-number-form-control'">
                    <input
                      nz-input
                      formControlName="unifiedNumber"
                      [placeholder]="'tenant.detail.placeholder.unified-number' | i18n"
                      [testId]="'tenant-detail-unified-number-input'"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-representative-number-form-item'">
                  <nz-form-label [nzSpan]="6">{{ 'tenant.detail.company-representative-number' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="18" [testId]="'tenant-detail-representative-number-form-control'">
                    <input
                      nz-input
                      formControlName="representativeNumber"
                      [placeholder]="'tenant.detail.placeholder.company-representative-number' | i18n"
                      [testId]="'tenant-detail-representative-number-input'"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <!-- 现有的联系邮箱和网站字段 -->
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="24">
                <nz-form-item [testId]="'tenant-detail-website-form-item'">
                  <nz-form-label [nzSpan]="3">{{ 'tenant.detail.company-website' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="21" [testId]="'tenant-detail-website-form-control'">
                    <input
                      nz-input
                      formControlName="website"
                      [placeholder]="'tenant.detail.placeholder.company-website' | i18n"
                      [testId]="'tenant-detail-website-input'"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <!-- 新增关联账号和是否可升级字段 -->
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="12">
                <nz-form-item [testId]="'tenant-detail-city-form-item'">
                  <nz-form-label [nzSpan]="6">{{ 'tenant.detail.company-address' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="18" [testId]="'tenant-detail-city-form-control'">
                    <nz-select
                      formControlName="city"
                      [nzPlaceHolder]="'tenant.detail.placeholder.company-address' | i18n"
                      nzAllowClear
                      [testId]="'tenant-detail-city-select'"
                    >
                      <nz-option
                        *ngFor="let item of cityOptions; trackBy: trackByValue"
                        [nzValue]="item.value"
                        [nzLabel]="item.text"
                        [testId]="'tenant-detail-city-option-' + item.value"
                      />
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <!-- 现有的地址字段 -->
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="24">
                <nz-form-item [testId]="'tenant-detail-address-form-item'">
                  <nz-form-label [nzSpan]="3">{{ 'tenant.detail.contact-address' | i18n }}</nz-form-label>
                  <nz-form-control [nzSpan]="21" [testId]="'tenant-detail-address-form-control'">
                    <input
                      nz-input
                      formControlName="address"
                      [placeholder]="'tenant.detail.placeholder.contact-address' | i18n"
                      [testId]="'tenant-detail-address-input'"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <!-- 现有的描述字段 -->
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="24">
                <nz-form-item [testId]="'tenant-detail-description-form-item'">
                  <nz-form-label [nzSpan]="3" nzRequired>{{ 'tenant.detail.tenant-description' | i18n }}</nz-form-label>
                  <nz-form-control
                    [nzSpan]="21"
                    [nzErrorTip]="'tenant.detail.error.tenant-description' | i18n"
                    [testId]="'tenant-detail-description-form-control'"
                  >
                    <textarea
                      nz-input
                      formControlName="description"
                      [placeholder]="'tenant.detail.placeholder.tenant-description' | i18n"
                      rows="4"
                      [testId]="'tenant-detail-description-textarea'"
                    ></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <!-- 移除原有的头像上传部分 -->
          </nz-card>
        </form>
      </nz-tab>

      <nz-tab *ngIf="shouldShowQuotaUsageTab" [nzTitle]="quotaUsageTitle" [testId]="'tenant-detail-quota-usage-tab'">
        <ng-template #quotaUsageTitle>
          <i nz-icon nzType="dashboard" nzTheme="outline"></i> {{ 'tenant.detail.quota-usage' | i18n }}
        </ng-template>
        <tenant-quota-usage
          *ngIf="isTabActive('quota-usage')"
          [tenantId]="tenantId"
          [tenantName]="tenantData?.name"
          [testId]="'tenant-detail-quota-usage-component'"
        />
      </nz-tab>

      <!-- 服务号列表标签页：按需渲染 -->
      <nz-tab [nzTitle]="serviceNumberTitle" [testId]="'tenant-detail-service-number-tab'">
        <ng-template #serviceNumberTitle>
          <i nz-icon nzType="appstore" nzTheme="outline"></i> {{ 'tenant.detail.service-number-list' | i18n }}
        </ng-template>
        <nz-card *ngIf="isTabActive('servicenumbers')" class="service-number-shell-card" [testId]="'tenant-detail-service-number-card'">
          <app-servicenumber-list
            [tenantId]="tenantId"
            [tenantType]="tenantData?.type"
            [viewMode]="'card'"
            [embeddedMode]="true"
            [testId]="'tenant-detail-service-number-list'"
          />
        </nz-card>
      </nz-tab>

      <!-- 员工管理标签页：按需渲染 -->
      <nz-tab [nzTitle]="userTitle" [testId]="'tenant-detail-employee-tab'">
        <ng-template #userTitle>
          <i nz-icon nzType="user" nzTheme="outline"></i> {{ 'tenant.detail.employee-management' | i18n }}
        </ng-template>
        <nz-card *ngIf="isTabActive('employees')" [testId]="'tenant-detail-employee-card'">
          <tenant-employee
            class="tab-mode"
            [tenantId]="tenantId"
            [tenantType]="tenantData?.type"
            [embeddedMode]="true"
            [testId]="'tenant-detail-employee-component'"
          />
        </nz-card>
      </nz-tab>

      <!-- 公网 IP 范围标签页：按需渲染 -->
      <nz-tab *ngIf="shouldShowIpRangeTab" [nzTitle]="ipRangeTitle" [testId]="'tenant-detail-ip-range-tab'">
        <ng-template #ipRangeTitle>
          <i nz-icon nzType="global" nzTheme="outline"></i> {{ 'tenant.employee.tab.ip-range' | i18n }}
        </ng-template>
        <nz-card *ngIf="isTabActive('ip-range')" [testId]="'tenant-detail-ip-range-card'">
          <tenant-ip-range class="tab-mode" [tenantId]="tenantId" [embeddedMode]="true" [testId]="'tenant-detail-ip-range-component'" />
        </nz-card>
      </nz-tab>

      <!-- 租户配置标签页：按需渲染 -->
      <nz-tab [nzTitle]="configTitle" [testId]="'tenant-detail-config-tab'">
        <ng-template #configTitle>
          <i nz-icon nzType="setting" nzTheme="outline"></i> {{ 'tenant.detail.tenant-config' | i18n }}</ng-template
        >
        <nz-card *ngIf="isTabActive('config')" [testId]="'tenant-detail-config-card'">
          <tenant-config [tenantId]="tenantId" [tenantType]="tenantData?.type" [testId]="'tenant-detail-config-component'" />
        </nz-card>
      </nz-tab>

      <nz-tab *ngIf="shouldShowCapabilityTab" [nzTitle]="capabilityTitle" [testId]="'tenant-detail-capability-tab'">
        <ng-template #capabilityTitle>
          <i nz-icon nzType="api" nzTheme="outline"></i> {{ 'tenant.detail.capability.section-title' | i18n }}
        </ng-template>
        <nz-card *ngIf="isTabActive('capability')" [testId]="'tenant-detail-capability-card'">
          <tenant-capability-config
            [tenantId]="tenantId"
            (capabilitiesChanged)="loadTenantCapability()"
            [testId]="'tenant-detail-capability-component'"
          />
        </nz-card>
      </nz-tab>

      <nz-tab [nzTitle]="callConfigTitle" [testId]="'tenant-detail-call-config-tab'">
        <ng-template #callConfigTitle>
          <i nz-icon nzType="phone" nzTheme="outline"></i> {{ 'tenant.detail.call-config.tab-title' | i18n }}
        </ng-template>
        <div *ngIf="isTabActive('call-config')" [testId]="'tenant-detail-call-config-panel'">
          <tenant-call-config [tenantId]="tenantId" [testId]="'tenant-detail-call-config-component'" />
        </div>
      </nz-tab>

      <nz-tab [nzTitle]="integrationAppsTitle" [testId]="'tenant-detail-integration-apps-tab'">
        <ng-template #integrationAppsTitle>
          <i nz-icon nzType="api" nzTheme="outline"></i> {{ 'tenant.detail.integration-apps.title' | i18n }}
        </ng-template>
        <div *ngIf="isTabActive('integration-apps')" [testId]="'tenant-detail-integration-apps-card'">
          <tenant-integration-apps
            [tenantId]="tenantId"
            [tenantName]="tenantData?.name"
            [tenantType]="tenantData?.type"
            [testId]="'tenant-detail-integration-apps-component'"
          />
        </div>
      </nz-tab>

      <nz-tab [nzTitle]="aiffTitle" [testId]="'tenant-detail-application-tab'">
        <ng-template #aiffTitle> <i nz-icon nzType="code" nzTheme="outline"></i> {{ 'tenant.detail.application-list' | i18n }}</ng-template>
        <nz-card *ngIf="isTabActive('aiff')" [testId]="'tenant-detail-application-card'">
          <aiff-list [tenantId]="tenantId" [embeddedMode]="true" [testId]="'tenant-detail-application-list'" />
        </nz-card>
      </nz-tab>

      <!-- 租户客户标签页：按需渲染 -->
      <nz-tab [nzTitle]="contactsTitle" [testId]="'tenant-detail-contacts-tab'">
        <ng-template #contactsTitle> <i nz-icon nzType="team" nzTheme="outline"></i> {{ 'tenant.detail.contacts' | i18n }} </ng-template>
        <nz-card *ngIf="isTabActive('contacts')" [testId]="'tenant-detail-contacts-card'">
          <tenant-contact-list
            [tenantId]="tenantId"
            [tenantType]="tenantData?.type"
            [embeddedMode]="true"
            [testId]="'tenant-detail-contacts-component'"
          />
        </nz-card>
      </nz-tab>
    </nz-tabset>
  </div>

  <!-- 优化加载中模板 -->
  <ng-template #loadingTpl>
    <div class="loading-container" [testId]="'tenant-detail-loading-container'">
      <nz-spin [nzSize]="'large'" [testId]="'tenant-detail-loading-spin'">
        <div class="loading-content" [testId]="'tenant-detail-loading-content'">
          <p [testId]="'tenant-detail-loading-text'">{{ 'tenant.detail.loading-tenant-info' | i18n }}</p>
        </div>
      </nz-spin>
    </div>
  </ng-template>
</div>

<!-- 替换原有的头像上传模态框 -->
<avatar-upload-modal
  [(visible)]="isAvatarModalVisible"
  [title]="'tenant.detail.upload-tenant-avatar' | i18n"
  [uploading]="isAvatarUploading"
  [aspectRatio]="1"
  [resizeToWidth]="300"
  (cancel)="handleAvatarModalCancel()"
  (ok)="handleAvatarCropped($event)"
  [testId]="'tenant-detail-avatar-upload-modal'"
/>

<image-viewer
  [(visible)]="imageViewerVisible"
  [imageUrl]="avatarUrl"
  [title]="'tenant.detail.image-preview' | i18n"
  [testId]="'tenant-detail-image-viewer'"
  (close)="closeImageViewer()"
/>
